import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  attendanceList: [],
  attendancePerPage: "",
  userName: "",
  attendanceTotal: 0,
  loading: false,
};

export const getUserList = createAsyncThunk(
  "get-user",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("user/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getUserAttendanceList = createAsyncThunk(
  "get-user-attendance",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("attendance/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createUser = createAsyncThunk(
  "create-user",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("user", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editUser = createAsyncThunk(
  "edit-user",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`user/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateUser = createAsyncThunk(
  "update-user",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/user/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteUser = createAsyncThunk(
  "delete-user",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/user/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.userList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getUserList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      })
      .addCase(getUserAttendanceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserAttendanceList.fulfilled, (state, action) => {
        state.loading = false;
        state.attendanceList =
          action?.payload?.data?.data?.listAttendanceRecord ?? [];
        state.userName = action?.payload?.data?.data?.userName ?? "";
        state.attendancePerPage = action?.payload?.data?.data?.perPage ?? 1;
        state.attendanceTotal = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getUserAttendanceList.rejected, (state, action) => {
        state.loading = false;
        state.attendanceList = [];
        state.userName = "";
        state.attendancePerPage = "";
        state.attendanceTotal = "";
      });
  },
});

export default userSlice.reducer;
